import React from 'react'
import './card.css'

export const Card = ({
    cardheader,
    cardbody,
    cardfooter
}) => {
    return (
        <div className='card'>
            <div className='card-Header'>{cardheader}</div>
            <div className='card-Body'>{cardbody}</div>
            <div className='card-Footer'>{cardfooter}</div>
        </div>
    )
}